// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"style_sidebarContainer__Biaxp","loaderContainer":"style_loaderContainer__j2Y2S"};